/**
 * Created by roi on 24/11/16.
 */
//import { initOptions, showSettingSection } from './options';
import '../../styles/client/styles.scss';
//import './jquery.range.min.js';

import './scripts.js';
import './popup';
import './slider-range';
import './submitForm';
import './slider';
import './submitFormTco';
import './financScript';




// WEBPACK FOOTER //
// ./assets/scripts/client/init.ts